import script from "./RelevancyCheckView.vue?vue&type=script&setup=true&lang=js"
export * from "./RelevancyCheckView.vue?vue&type=script&setup=true&lang=js"

import "./RelevancyCheckView.vue?vue&type=style&index=0&id=1b67e133&lang=scss"

const __exports__ = script;

export default __exports__